import { Component, Input } from '@angular/core';

@Component({
    selector: 'jhi-save-draft-requete-button',
    templateUrl: './save-draft-requete-button.component.html'
})
export class SaveDraftRequeteButtonComponent {
    isLoading: boolean;
    @Input() isDisabled: boolean;

    @Input() clickHandler: Function;

    constructor() {}

    onClickButton() {
        this.disableButton();

        let observable = this.clickHandler();
        if (observable) {
            observable.subscribe(
                () => this.enableButton(),
                () => this.enableButton()
            );
        } else {
            this.enableButton();
        }
    }

    disableButton() {
        this.isDisabled = true;
        this.isLoading = true;
    }

    enableButton() {
        this.isDisabled = false;
        this.isLoading = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/button/save-draft-requete-button/save-draft-requete-button.component.ts